import type { TimeSeries } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { BadgeItem } from '../../../../components/generic/BadgeItem';
import type { UseTimeseriesChartReturn } from '../../../participantData/hooks/useTimeseriesChart';
import {
  AGGREGATION_TYPE_OPTIONS_MAP,
  CHART_TYPE_OPTIONS_MAP,
  METHOD_TYPE_OPTIONS_MAP,
} from '../../../participantData/utils';
import { AggregationTypeIcon } from './AggregationTypeIcon';
import { ChartTypeIcon } from './ChartTypeIcon';
import { TimeSeriesAliasSquare } from './TimeSeriesAliasSquare';

interface Props {
  chart: UseTimeseriesChartReturn;
  series: TimeSeries;
  onClick: () => void;
}

export const TimeSeriesButtonGroup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { chart, series, onClick } = props;

  const index = chart.widget.series.findIndex((s) => s.id === series.id);
  const chartType = CHART_TYPE_OPTIONS_MAP[series.__typename!];
  const aggregationType = AGGREGATION_TYPE_OPTIONS_MAP[series.aggregation];
  const method = METHOD_TYPE_OPTIONS_MAP[series.source.method];

  const onRemove = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    chart.onRemoveSeries(series.id);
  };

  return (
    <ChakraV3.ButtonGroup ref={ref} size='sm' attached variant='outline' onClick={onClick}>
      <ChakraV3.Button p={1.5}>
        <TimeSeriesAliasSquare alias={`${index + 1}`} series={series} />
      </ChakraV3.Button>
      <ChakraV3.Button px={1.5}>
        <BadgeItem label={method.label} color={method.color} />
      </ChakraV3.Button>
      <ChakraV3.Button px={1.5}>
        <BadgeItem
          label={chartType.label}
          color={chartType.color}
          icon={<ChartTypeIcon chartType={chartType.raw} size={16} />}
        />
      </ChakraV3.Button>
      <ChakraV3.Button px={1.5}>
        <BadgeItem
          label={aggregationType.label}
          color={aggregationType.color}
          icon={<AggregationTypeIcon aggregationType={aggregationType.raw} size={16} />}
        />
      </ChakraV3.Button>
      <ChakraV3.IconButton onClick={onRemove} aria-label='Remove method'>
        <FaTimes />
      </ChakraV3.IconButton>
    </ChakraV3.ButtonGroup>
  );
});
